import React, { FC } from 'react'
import { QuoteImage } from '../../../constants/svg'
import { ComponentQuote } from '../../../models/components/quote'
import { QuoteInner, QuoteOuter } from './style'
import { QuoteBlock } from './subcomponents/quoteBlock'

type Props = {
  data: ComponentQuote
  isPanel?: boolean
  slidePrevClick?: any
  slideNextClick?: any
  itemNum?: number
  totalItems?: number
  themeOverride?: string
}

const Quote: FC<Props> = ({ data, themeOverride }) => {
  const quoteData = {
    authorName: data.authorName || '',
    authorTitle: data.authorTitle || '',
    body: data.body?.body || data.body || '',
    company: data.company || '',
    quoteCta: data.quoteCta || ('cta' in data && data.cta) || null,
    image: data.image || null,
    theme: themeOverride || data.theme || 'Light',
  }

  return (
    <QuoteOuter $quoteTheme={quoteData.theme} data-cy="quote">
      <QuoteInner>
        <QuoteImage />
        <QuoteBlock quoteData={quoteData} />
      </QuoteInner>
    </QuoteOuter>
  )
}

export default Quote
